import React from 'react';

import { COMPANY_COMMUNITY_RELATION_TYPE } from 'constants/company';

import OverviewCommunitiesTable from './OverviewCommunitiesTable';
import { useAppSelector } from '../../store/hook';

const OverviewCommunities = () => {
  const { communities } = useAppSelector((state) => state.global);

  return <OverviewCommunitiesTable type={COMPANY_COMMUNITY_RELATION_TYPE.COMMUNITY} communities={communities} />;
};

export default OverviewCommunities;
